import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, SendPaylinkDialogueHandler } from '../types';
import SendPaylinkContext from './PaylinkContext';

const { ConfirmationDialogue } = vp;

type SendPaylinkDialogueProps = {
  handleDialogue: DialogueHandler<SendPaylinkDialogueHandler>;
};

type FC = FunctionComponent<SendPaylinkDialogueProps>;

const SendPaylinkDialogue: FC = ({ handleDialogue }: SendPaylinkDialogueProps) => {
  const { showSendPaylinkSuccessAlert, showSendPaylinkErrorAlert, sendPaylinkError, payLink } =
    useContext(SendPaylinkContext);

  return useMemo(
    () => (
      <div>
        {/* Send Paylink Error */}
        <ConfirmationDialogue
          isVisible={showSendPaylinkErrorAlert}
          title="Error! The Pay Link was not sent."
          status="error"
          subTitle={`${sendPaylinkError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />
        {/* Send Paylink Success */}
        <ConfirmationDialogue
          isVisible={showSendPaylinkSuccessAlert}
          title="Pay Link successfully sent."
          status="success"
          subTitle="An email with the pay link request has been sent to the email address you provided. The link is also available below in case you need it. Once the request is completed your transaction will be processed."
          content={payLink}
          confirm={{
            label: 'Back to Contacts',
            action: () => handleDialogue({ type: 'confirm', state: 'confirm' }),
          }}
          cancel={{
            label: 'View Request Details',
            action: () => handleDialogue({ type: 'confirm', state: 'view' }),
          }}
        />
      </div>
    ),
    [showSendPaylinkSuccessAlert, showSendPaylinkErrorAlert, sendPaylinkError, payLink],
  );
};

export default SendPaylinkDialogue;
